import { Formik } from 'formik'
import { ReactNode } from 'react'

import { useSwitch2FAMethod } from 'src/hooks'
import { IVerificationCodeForm } from 'src/types'
import { codeVerificationSchema } from 'src/common/validations'

interface IProps {
  children: ReactNode
}

export const SwitchFormWrapper = ({ children }: IProps) => {
  const { mutateAsync: switch2FAMethod } = useSwitch2FAMethod()

  const handleSubmit = async (values: IVerificationCodeForm) => {
    await switch2FAMethod(values.code)
  }

  return (
    <Formik
      validationSchema={codeVerificationSchema}
      initialValues={{ code: '' }}
      onSubmit={handleSubmit}
    >
      {children}
    </Formik>
  )
}
